import { createStore } from 'vuex'

export default createStore({
  state: {
    selectedImages:[] // 自拼舒尔特练习纸图片单词空数组
    
  },
  getters: {
    getSelectImage(state){
      return state.selectedImages;
    }
  },
  mutations: {
    set_select_image(state,images){
      state.selectedImages=images;
    }
  },
  actions: {
    setImages({commit},images){
      commit('set_select_image',images);
    },
    clearImages({commit}){
      commit('set_select_image',[]);
    }
  },
  modules: {
  }
})
